import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { externalOnboardingChangeStep } from 'actions/externalOnboarding';
import ProgressBarStepper from 'complexComponents/ProgressBarStepper';
import { externalStepsToProgressBarSteps, findPreviousActiveStepIndex, shouldDisableBackButton, } from 'helpers/progressBarStepper';
import { useSelectorWithProps } from 'hooks';
import { initialStepIndexSelector } from 'queries/currentWorkflowStepSelector';
import { externalOnboardingStepSelector } from 'selectors/externalOnboardingSelectors';
const ExternalOnboardingProgressBarStepperContainer = ({ allowBackButtonNavigation, allowStepButtonNavigation, steps, }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const activeStepIndex = useSelector(externalOnboardingStepSelector);
    const initialStepIndex = useSelectorWithProps(initialStepIndexSelector, { location });
    const progressBarSteps = externalStepsToProgressBarSteps({ activeStepIndex, initialStepIndex, steps });
    const isBackButtonDisabled = shouldDisableBackButton({ steps, activeStepIndex });
    const setActiveStepIndex = (stepIndex) => {
        dispatch(externalOnboardingChangeStep(stepIndex));
    };
    const onClickBackButton = () => {
        setActiveStepIndex(findPreviousActiveStepIndex({ stepIndex: activeStepIndex, steps }));
    };
    const backButtonProps = allowBackButtonNavigation
        ? { onClick: onClickBackButton, isDisabled: isBackButtonDisabled }
        : undefined;
    return (React.createElement(ProgressBarStepper, { backButton: backButtonProps, onClickStep: allowStepButtonNavigation ? setActiveStepIndex : undefined, steps: progressBarSteps }));
};
export default ExternalOnboardingProgressBarStepperContainer;
